/**
 * Componente de Exibição de Erro
 * Mostra mensagens de erro com opção de retry
 */

import React from 'react';

const ErrorDisplay = ({ error, onRetry, darkMode }) => {
  return (
    <div className={`min-h-[400px] flex flex-col items-center justify-center p-8 ${darkMode ? 'text-slate-300' : 'text-slate-600'
      }`}>
      <div className={`p-6 rounded-2xl max-w-md text-center ${darkMode
        ? 'bg-red-500/10 border border-red-500/30'
        : 'bg-red-50 border border-red-200'
        }`}>
        <div className="text-5xl mb-4">😵</div>
        <h3 className={`text-xl font-bold mb-2 ${darkMode ? 'text-red-400' : 'text-red-600'}`}>
          Erro ao carregar dados
        </h3>
        <p className={`mb-4 ${darkMode ? 'text-slate-400' : 'text-slate-600'}`}>
          {error || 'Não foi possível conectar ao servidor.'}
        </p>
        <p className={`text-sm mb-6 ${darkMode ? 'text-slate-500' : 'text-slate-500'}`}>
          Verifique sua conexão com a internet e tente novamente.
        </p>
        <button
          onClick={onRetry}
          className="px-6 py-3 rounded-xl font-medium text-white transition-all hover:scale-105"
          style={{ background: 'linear-gradient(135deg, #0974BA, #13983D)' }}
        >
          Tentar novamente
        </button>
      </div>
    </div>
  );
};

export default ErrorDisplay;
